var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyMedisSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99951 22.2983C3.34266 22.2983 1.99951 20.9551 1.99951 19.2983V9.35574C1.99951 8.30195 2.55241 7.32543 3.45602 6.78326L10.456 2.58326C11.4061 2.01324 12.593 2.01323 13.543 2.58326L20.543 6.78326C21.4466 7.32543 21.9995 8.30195 21.9995 9.35574V19.2983C21.9995 20.9551 20.6564 22.2983 18.9995 22.2983H4.99951ZM19.9995 9.35574V19.2983C19.9995 19.8505 19.5518 20.2983 18.9995 20.2983H15.9995V16.2983C15.9995 15.1937 15.1041 14.2983 13.9995 14.2983H9.99951C8.89494 14.2983 7.99951 15.1937 7.99951 16.2983V20.2983H4.99951C4.44723 20.2983 3.99951 19.8505 3.99951 19.2983V9.35574C3.99951 9.00448 4.18381 8.67897 4.48502 8.49825L11.485 4.29825C11.8017 4.10824 12.1973 4.10824 12.514 4.29825L19.514 8.49825C19.8152 8.67897 19.9995 9.00448 19.9995 9.35574ZM9.99951 20.2983H13.9995V16.2983H9.99951V20.2983Z",
    fill: "#00214D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyMedisSvg);
export default __webpack_public_path__ + "static/media/iconMyMedisSvg.d9d8609cb12cbd0245a7b39496fda525.svg";
export { ForwardRef as ReactComponent };